import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MembersRoutingModule } from './members-routing.module';
import { MembersListingComponent } from './members-listing/members-listing.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { EmailMembersComponent } from './email-members/email-members.component';
@NgModule({
  declarations: [MemberDetailsComponent, MembersListingComponent, EmailMembersComponent],
  imports: [
    CommonModule,
    SharedModule,
    MembersRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule
  ]
})
export class MembersCLAModule { }
